<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/admin'}">Admin</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        Version {{ClientVersion}}
        &copy;2022-{{ new Date().getFullYear() }} Prevention Risques Pro 
        
        <a href="https://www.prevention-risquespro.fr" target="_blank">APR</a>.
        
      </div>
    </div>
  </footer>
</template>
<script>
import Business from 'ppe-business'
  export default {
    data () { return {
      ClientVersion : Business.ClientVersion,
      
      }
    }
  }

</script>
<style>

</style>
